// One vocabulary for the emergency-contact relation (user_profiles.urgence_relation,
// students.emergency_contact_relation). Ten codes decided on 2026-10-21, the same
// list on every form (students, staff, admins, own profile) and on mobile. Every
// screen displays through emergencyRelationLabel(); the API maps the codes written
// by older forms (spouse, sibling, ...) on save, so no dropdown needs a legacy entry.

export interface EmergencyRelationOption {
  value: string;
  label: string;
}

export const EMERGENCY_RELATION_OPTIONS: EmergencyRelationOption[] = [
  { value: 'pere', label: 'Père' },
  { value: 'mere', label: 'Mère' },
  { value: 'frere', label: 'Frère' },
  { value: 'soeur', label: 'Sœur' },
  { value: 'oncle', label: 'Oncle' },
  { value: 'tante', label: 'Tante' },
  { value: 'ami', label: 'Ami(e)' },
  { value: 'tuteur', label: 'Tuteur légal' },
  { value: 'conjoint', label: 'Conjoint(e)' },
  { value: 'autre', label: 'Autre' },
];

export const EMERGENCY_RELATION_LABELS: Record<string, string> = Object.fromEntries(
  EMERGENCY_RELATION_OPTIONS.map((o) => [o.value, o.label]),
);

/** French label for a stored code; the raw text when unknown; '' when empty. */
export function emergencyRelationLabel(value: string | null | undefined): string {
  if (!value) return '';
  return EMERGENCY_RELATION_LABELS[value] ?? value;
}

/** Options for a <select>: the placeholder followed by the ten codes. */
export function emergencyRelationSelectOptions(_current?: string | null): EmergencyRelationOption[] {
  return [{ value: '', label: 'Sélectionner...' }, ...EMERGENCY_RELATION_OPTIONS];
}
